module.exports = __webpack_public_path__ + "img/1657180315504.f4f90dd8.jpg";